import { Props_SnippetImageCardGrid } from "./ImageCardGrid.props"
import SnippetLink from '../Shared/Link/Link'


const SnippetImageCardGrid = (props: Props_SnippetImageCardGrid) => {
    const { heading, repeatable_card } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-image-card-grid__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-image-card-grid">
            <div className="snippet-image-card-grid__container">
                <h2 className={`snippet-image-card-grid__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                <div className="snippet-image-card-grid__grid">
                    {repeatable_card.map((card, index) => (
                        <div key={index} className="snippet-image-card-grid__card">
                            <img
                                loading="lazy"
                                src={card.image?.value}
                                className="snippet-image-card-grid__card-image"
                                alt={card.imageAltText?.value}
                                width={644}
                                height={618}
                            />
                            <div className="snippet-image-card-grid__card-content-overlay">
                                {card.cardHeading?.value &&
                                    <h3 className="snippet-image-card-grid__card-heading">{card.cardHeading.value}</h3>
                                }
                                 <SnippetLink
                                    linkStyles={card.linkStyle?.value}
                                    className="snippet-image-card-grid__card-link"
                                    url={card.linkHref?.value}
                                    target={card.linkTarget?.value}
                                >
                                    {card.linkContent?.value}
                                </SnippetLink>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetImageCardGrid;